import React from 'react'
import Sidebar from '../../components/sidebar/Sidebar'
import Navbar from '../../components/navbar/Navbar'

export default function settings() {
    function handleBackgroundColor() {
        var body = document.querySelector("body");
        body.style.backgroundColor = "grey";
    }
    function handleFontColor() {
        var body = document.querySelector("body");
        body.style.color = "green";
    }
    function handleHeadingColor() {
        var body = document.querySelectorAll("h1,h2,h3,h4,h5,h6");
        body.style.color = "orange";
    }
    const handleFont1=()=> {
        var body = document.querySelector("p");
        body.style.fontFamily = "Comfortaa"; 
    }
    const handleFont2 = () => {
        var body = document.querySelector("p");
        body.style.fontFamily = "Russo One";
    }
    const handleFont3 = () => {
        var body = document.querySelector("p");
        body.style.fontFamily = "Inconsolata";
    }
  return (
      <>
          <div className="home">
              <Sidebar />
              <div className="homeContainer">
                  <Navbar />
                  <div className='d-flex'>
                      <button className='btn btn-warning' onClick={handleBackgroundColor}>Grey Body Background</button>
                      <button className='btn btn-warning' onClick={handleFontColor}>Green Font Color</button>
                      <button className='btn btn-warning' onClick={handleHeadingColor}>Orange Headings</button>
                  </div>
                  <div className='d-flex'>
                      <button className='btn btn-warning' style={{ fontFamily: 'Comfortaa' }} onClick={handleFont1}>Font Comfortaa</button>
                      <button className='btn btn-warning' style={{ fontFamily: 'Russo-One' }} onClick={handleFont2}>Font Russo-One</button>
                      <button className='btn btn-warning' style={{ fontFamily: 'Inconsolata' }} onClick={handleFont3}>Font Inconsolata</button>

                  </div>
              </div>
          </div>
      

      
      </>
  )
}
